<template>
  <div>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Bootstrap Navs</strong>
        <div class="card-header-actions">
          <a
            href="https://coreui.io/vue/docs/components/nav"
            class="card-header-action"
            rel="noreferrer noopener"
            target="_blank"
          >
            <small class="text-muted">docs</small>
          </a>
        </div>
      </c-card-header>
      <c-card-body>
        <c-nav>
          <c-nav-item active>Active</c-nav-item>
          <c-nav-item title="Link" />
          <c-nav-item>Another Link</c-nav-item>
          <c-nav-item disabled>Disabled</c-nav-item>
        </c-nav>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Bootstrap Navs</strong>
        <small>icons</small>
      </c-card-header>
      <c-card-body>
        <c-nav variant="pills">
          <c-nav-item active>
            <c-icon name="cil-basket" />
          </c-nav-item>
          <c-nav-item>
            <c-icon name="cil-settings" />
          </c-nav-item>
          <c-nav-item>
            <c-icon name="cil-bell" />
          </c-nav-item>
          <c-nav-item disabled>
            <c-icon name="cil-envelope-closed" />
          </c-nav-item>
        </c-nav>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Bootstrap Navs</strong>
        <small>tab style</small>
      </c-card-header>
      <c-card-body>
        <c-nav variant="tabs">
          <c-nav-item active>
            Active
          </c-nav-item>
          <c-nav-item>
            Link
          </c-nav-item>
          <c-nav-item>
            Another Link
          </c-nav-item>
          <c-nav-item disabled>Disabled</c-nav-item>
        </c-nav>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header @click="item++">
        <c-icon name="cil-justify-center" />
        <strong>Bootstrap Navs</strong>
        <small>pill style</small>
      </c-card-header>
      <c-card-body>
        <c-nav variant="pills">
          <c-nav-item active>Active</c-nav-item>
          <c-nav-item>Link</c-nav-item>
          <c-nav-item>Another Link</c-nav-item>
          <c-nav-item disabled>Disabled</c-nav-item>
        </c-nav>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Bootstrap Navs</strong>
        <small>fill tabs</small>
      </c-card-header>
      <c-card-body>
        <c-nav fill variant="tabs">
          <c-nav-item active>Active</c-nav-item>
          <c-nav-item>Link</c-nav-item>
          <c-nav-item>Link with a long name</c-nav-item>
          <c-nav-item disabled>Disabled</c-nav-item>
        </c-nav>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Bootstrap Navs</strong>
        <small>justified tabs</small>
      </c-card-header>
      <c-card-body>
        <c-nav justified variant="tabs">
          <c-nav-item active>Active</c-nav-item>
          <c-nav-item>Link</c-nav-item>
          <c-nav-item>Link with a long name</c-nav-item>
          <c-nav-item disabled>Disabled</c-nav-item>
        </c-nav>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Bootstrap Navs</strong>
        <small>dropdown support</small>
      </c-card-header>
      <c-card-body>
        <c-nav variant="pills">
          <c-nav-item>Active</c-nav-item>
          <c-nav-item>Link</c-nav-item>
          <c-dropdown in-nav placement="bottom-end" button-content="Dropdown">
            <c-dropdown-item>one</c-dropdown-item>
            <c-dropdown-item>two</c-dropdown-item>
            <c-dropdown-divider />
            <c-dropdown-item>three</c-dropdown-item>
          </c-dropdown>
        </c-nav>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Bootstrap Navs</strong>
        <small>vertical variation</small>
      </c-card-header>
      <c-card-body>
        <c-row>
          <c-col col="3" class="m-0">
            <c-nav vertical pills>
              <c-nav-item active>Active</c-nav-item>
              <c-nav-item>Link</c-nav-item>
              <c-nav-item>Another Link</c-nav-item>
              <c-nav-item disabled>Disabled</c-nav-item>
            </c-nav>
          </c-col>
        </c-row>
      </c-card-body>
    </c-card>
  </div>
</template>

<script>
export default {
  name: 'Navs',
};
</script>
